import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { RegisterName } from '@schir-int-client/register-shared';
import { NewVerfahren } from '@schir-int-client/verfahren-shared';
import { addAriaAttributesToMatSelect, BaseEditorComponent } from '@schir-int-client/tech';
import { ApiRootFacade } from '@schir-int-client/api-root';
import { filter } from 'rxjs/operators';
import { isNil } from 'lodash-es';
import { UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'schir-int-client-create-verfahren-dialog',
	templateUrl: './create-verfahren-dialog.component.html',
	styleUrls: ['./create-verfahren-dialog.component.scss'],
	standalone: false,
})
export class CreateVerfahrenDialogComponent extends BaseEditorComponent implements OnInit, OnDestroy {
	readonly registerControlName = 'register';
	readonly blattnummerControlName = 'blattnummer';

	readonly registerName = RegisterName;

	@Output() onCreateNewVerfahren: EventEmitter<NewVerfahren> = new EventEmitter();
	hasBlattnummerInput: boolean;

	blattnummerGenerieren: boolean = false;

	registerSelectionList: RegisterName[];

	private readonly subscription: Subscription;

	blattnummerValidator(): ValidatorFn {
		return (group: UntypedFormGroup): ValidationErrors => {
			const value = group?.value;
			return !value || /^[1-9][0-9]{0,7}$/.test(value) ? null : { wrongBlattnummer: true };
		};
	}

	form: UntypedFormGroup = new UntypedFormGroup({
		[this.registerControlName]: new UntypedFormControl(null, Validators.required),
		[this.blattnummerControlName]: new UntypedFormControl(null, this.blattnummerValidator()),
	});

	constructor(@Inject(MAT_DIALOG_DATA) data: any, apiRootFacade: ApiRootFacade) {
		super();

		this.hasBlattnummerInput = data.hasBlattnummerInput;
		this.blattnummerControl.markAsTouched();

		this.subscription = apiRootFacade
			.getCurrentApiRoot()
			.pipe(filter(apiRoot => !isNil(apiRoot)))
			.subscribe(apiRoot => {
				this.registerSelectionList = apiRoot.features.registers.map(elem => (<any>RegisterName)[elem]);

				this.registerControl.patchValue(apiRoot.features.lfpr ? RegisterName.LR : RegisterName.SSR);
			});
	}

	ngOnInit(): void {
		addAriaAttributesToMatSelect();
	}

	async submit(): Promise<boolean> {
		const verfahren: NewVerfahren = {
			register: this.registerControl.value,
			blattNummer: this.blattnummer,
		};

		this.onCreateNewVerfahren.emit(verfahren);

		return true;
	}

	get blattnummer(): number {
		return this.blattnummerGenerieren ? null : this.blattnummerControl.value;
	}

	get blattnummerControl(): UntypedFormControl {
		return <UntypedFormControl>this.form.controls[this.blattnummerControlName];
	}

	get registerControl(): UntypedFormControl {
		return <UntypedFormControl>this.form.controls[this.registerControlName];
	}

	ngOnDestroy(): void {
		this.subscription?.unsubscribe();
	}
}
